module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAi0lEQVRIx2P4Twq4JGBCPGKgt9GP3v2kldGuE65S3+hFJ14pVJ1lyjgOJIFsKrs6eMZNhvRjQJL6AZK25O6tl9/TltwZailk0BsNjDHiEUnuGNxG/3ryglZG3wvMpr7R75Zvva7nd1nQFEi+W7GVyq5+GFcGTAxAkvoB8iS/9cedR08KWodaChkAowGFELY6kJ6PMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/pa.png
// module id = 900
// module chunks = 0